/**
 * Esqueleto da home enquanto a loja carrega, no lugar do spinner de tela
 * cheia: o cliente já vê a forma da página e a espera parece menor.
 * Só no celular — o autoatendimento continua com o LoadingWall.
 */
export default function HomeSkeleton() {
  return (
    <div className="home-skeleton" aria-busy="true" aria-live="polite">
      <span className="visually-hidden">Carregando o cardápio...</span>
      <div className="shop-cover__band skeleton-block" />
      <div className="home-skeleton__cover">
        <div className="skeleton-block home-skeleton__logo" />
        <div className="skeleton-block home-skeleton__line home-skeleton__line--title" />
        <div className="skeleton-block home-skeleton__line home-skeleton__line--chip" />
        <div className="skeleton-block home-skeleton__line home-skeleton__line--meta" />
      </div>
      <div className="skeleton-block home-skeleton__search" />
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="home-skeleton__item">
          <div className="home-skeleton__text">
            <div className="skeleton-block home-skeleton__line home-skeleton__line--name" />
            <div className="skeleton-block home-skeleton__line" />
            <div className="skeleton-block home-skeleton__line home-skeleton__line--short" />
          </div>
          <div className="skeleton-block home-skeleton__img" />
        </div>
      ))}
    </div>
  );
}
